import { create } from 'zustand';
import type { VersionControlProps } from '../components/Layout/VersionControlDropdown';

interface VersionControlStore {
  versionControlProps: VersionControlProps | null;
  setVersionControlProps: (props: VersionControlProps | null) => void;
  isProductionView: boolean;
  setIsProductionView: (value: boolean) => void;
}

export const useVersionControlStore = create<VersionControlStore>((set) => ({
  versionControlProps: null,
  setVersionControlProps: (props) => set({ versionControlProps: props }),
  isProductionView: false,
  setIsProductionView: (value) => set({ isProductionView: value }),
}));
